import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"search\">\n  <path fill=\"#352C0B\" fill-rule=\"evenodd\" d=\"M49.688 9.02a31.245 31.245 0 1 0 8.762 52.597L79.41 82.58a2.25 2.25 0 1 0 3.18-3.181L61.63 58.434A31.246 31.246 0 0 0 49.688 9.02Zm-11.937 2.23a26.747 26.747 0 1 1-24.37 37.208l-2.071.88 2.07-.88A26.745 26.745 0 0 1 37.752 11.25Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol